module.exports = __webpack_public_path__ + "static/Factorial-ae7b02f41a74b93ac5842e9e6a43c0f0.jpg";